import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { OtaThemeProvider } from '@ota/design-system';
import { createQueryClient } from '@ota/api-client';
import { App } from './App';

const queryClient = createQueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <OtaThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </OtaThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
